const Privacy = () => {
    const privacyText = `
  개인정보처리방침
  
  [ChainSpace]는 회원의 개인정보를 중요시하며, 관련 법령에 따라 보호하고 있습니다.
  
  1. 수집하는 개인정보 항목
  - 이름, 이메일, 지갑 주소, 프로필 이미지, 접속기록 등
  
  2. 개인정보 수집 목적
  - 회원 관리
  - NFT 거래 및 이용 내역 확인
  - 보안 및 서비스 개선
  
  3. 개인정보 보유 및 이용 기간
  - 회원 탈퇴 후 즉시 파기하거나 관련 법령에 따른 기간 동안 보관합니다.
  
  4. 개인정보 제3자 제공
  - 원칙적으로 회원 동의 없이 외부에 제공하지 않습니다.
  - 단, 법령에 의거하거나 수사기관의 요청이 있는 경우 예외로 합니다.
  
  5. 이용자의 권리
  - 회원은 자신의 개인정보 열람, 수정, 삭제를 요청할 수 있습니다.
  
  6. 쿠키의 사용
  - 로그인 상태 유지를 위해 쿠키를 사용할 수 있으며, 사용자는 브라우저 설정을 통해 이를 거부할 수 있습니다.
  
  7. 개인정보 보호책임자
  - 이름: Lee
  - 이메일: Lee@naver.com 
  
  부칙
  본 방침은 2025년 4월 14일부터 적용됩니다.
  `;
  
    return (
      <div style={{ padding: '2rem', textAlign: 'left' }}>
        <h1>개인정보처리방침</h1>
        <p style={{ whiteSpace: 'pre-line' }}>{privacyText}</p>
      </div>
    );
  };
  
  export default Privacy;
  